import React from 'react';

import { GridActionButton, GridRightPanelProps } from '../grid-types';
import { ActionButtonComponent } from './action-button-component';

export const actionButtonsFactory = (buttons: GridActionButton[]) => (
  props: GridRightPanelProps
) => {
  return renderActionButtons(buttons, props);
};

export const renderActionButtons = (
  buttons: GridActionButton[],
  props: GridRightPanelProps
) => (
  <>
    {buttons.map(
      ({ id, label, onClick, Component = ActionButtonComponent }) => (
        <Component
          key={id}
          label={label}
          onClick={onClick}
          {...props}
        ></Component>
      )
    )}
  </>
);
